import { axios, getConfigs, IRequestConfig } from './api'

export type ReportDictationMode = 'RT_ASR' | 'MANUAL' | 'EH_INFERENCE'

export enum FilterType {
  STATUS = 'status',
  RADIOLOGY_STUDY = 'radiologyStudy',
}

export interface OrderFilterTab {
  id: string
  type: FilterType
  value: string | boolean
  label?: string
}

export interface MemberPreferenceConfigDto {
  memberId: number
  reportDictationMode: ReportDictationMode
  orderFilters?: OrderFilterTab[] | null
}

export class MemberPreferenceConfigService {
  private static readonly endpoint = 'member-preference-config'

  static getByMemberId(memberId: number): Promise<MemberPreferenceConfigDto> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        `${this.endpoint}/${memberId}`,
        {},
      )
      axios(configs, resolve, reject)
    })
  }

  static upsert(
    dto: MemberPreferenceConfigDto,
  ): Promise<MemberPreferenceConfigDto> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        this.endpoint,
        {},
      )
      configs.data = dto
      axios(configs, resolve, reject)
    })
  }
}
